import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsVerificationStatus, PmsVerificationStatus } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsVerificationStatus>
    useData={usePmsVerificationStatus}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
